import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: ${props => props.theme.spacing.sp8};
  row-gap: ${props => props.theme.spacing.sp4};
`

export const Footer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const Counter = styled.div`
  margin-left: auto;
`
